module.exports = __webpack_public_path__ + "img/hand-point-up.da5e9870.svg";